import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  useLocation,
  useRoutes,
} from "react-router-dom";
import AuthLayout from "../layouts/auth-layout";
import DashboardLayout from "../layouts/dashboard-layout";
import Login from "../pages/auth/login";
import Dashboard from "../pages/dashboard";
import ForgotPassword from "../pages/auth/forgot-password";
import UpdatePassword from "../pages/auth/update-password";
import MainLayout from "../layouts/main-layout";
import NotFound from "../components/NotFound/NotFound";
import Forbidden from "../components/Forbidden/Forbidden";
import { UserContext } from "../context";
import ResetPassword from "../pages/auth/reset-password";
// import Ticketlist from "../pages/dashboard/tickets/list";
import UserAuth from "../pages/auth/UserAuth";
import JsonMapping from "../pages/dashboard/json-mapping/list";
import AdminDashboard from "../pages/admin/dashboard/list";
import StudentForm from "../pages/forms/current/student/student_form";
import TeacherForm from "../pages/forms/current/teacher/teacher_form";
import SchoolForm from "../pages/forms/current/school/school_form";
import MyApplications from "../pages/my-applications/my-applications";

const routes = [
  {
    path: "/login",
    element: (
      <AuthLayout>
        <UserAuth />
      </AuthLayout>
    ),
  },
  {
    path: "/forgot-password",
    element: (
      <AuthLayout>
        <ForgotPassword />
      </AuthLayout>
    ),
  },
  {
    path: "/update-password",
    element: (
      <MainLayout>
        <UpdatePassword />
      </MainLayout>
    ),
  },
  {
    path: "/reset-password",
    element: (
      <MainLayout>
        <ResetPassword />
      </MainLayout>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <DashboardLayout>
        <Dashboard />
      </DashboardLayout>
    ),
  },

  {
    path: "/student-form",
    element: (
      <DashboardLayout>
        <StudentForm />
      </DashboardLayout>
    ),
  },
  {
    path: "/teacher-form",
    element: (
      <DashboardLayout>
        <TeacherForm />
      </DashboardLayout>
    ),
  },
  {
    path: "/school-form",
    element: (
      <DashboardLayout>
        <SchoolForm />
      </DashboardLayout>
    ),
  },

  {
    path: "/my-applications",
    element: (
      <DashboardLayout>
        <MyApplications />
      </DashboardLayout>
    ),
  },

  {
    path: "/dashboard/json-mapping",
    element: (
      <DashboardLayout>
        <JsonMapping />
      </DashboardLayout>
    ),
  },
  {
    path: "admin/dashboard",
    element: (
      <DashboardLayout>
        <AdminDashboard />
      </DashboardLayout>
    ),
  },
  {
    path: "/",
    element: (
      <Navigate
        to='/login'
        replace
      />
    ),
  },
  {
    path: "*",
    element: (
      <DashboardLayout>
        <NotFound />
      </DashboardLayout>
    ),
  },
  {
    path: "/forbidden",
    element: (
      <DashboardLayout>
        <Forbidden />
      </DashboardLayout>
    ),
  },
];

// const ProtectedRoute = ({ element }: { element: JSX.Element }) => {
//   const userData: any = useContext(UserContext);
//   const authorizedRoutes =
//     userData?.menuHierarchy?.map((item: any) =>
//       item?.entityUrl.toLocaleLowerCase()
//     ) || [];

//   const location = useLocation();
//   const currentPath = location.pathname.toLocaleLowerCase();

//   // Define excluded paths
//   const excludedPaths = ["/dashboard/dealers/form", "/dashboard/ticket/form"];

//   // Check if the current path is excluded
//   const isExcluded = excludedPaths.includes(currentPath);

//   // Check authorization only for non-excluded paths
//   const isAuthorized = isExcluded || authorizedRoutes?.includes(currentPath);

//   return element;
// };

const AppRoutes: React.FC = () => {
  const element = useRoutes(routes);

  return <>{element}</>;
};

const App: React.FC = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default App;
